import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import LayoutHeader from '../../layout/LayoutHeader';
import { setErrorAlert, setSuccessAlert, setLoader } from '../../store/alert/alertSlice';
import { get_user_articles_thunk, update_user_article_thunk } from '../../store/user/userThunk';
import { setUserArticle } from '../../store/user/userSlice';
import { uploadImage } from '../../utils/upload';
import axios from '../../utils/axios';
import Check from '../../svg/Check';
import ImageCard from '../../components/More/ImageCard';
import { DizeeInput2 } from '../../components/DizeeComponent/DixeeInput2';

export default function TeamMemberProfile() {
    const token = localStorage.getItem('dizeeToken')
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [email, setEmail] = useState('')
    const [username, setUsername] = useState('')
    const userArticle = useSelector((state) => state.user.userArticle);
    const [selectedImage, setSelectedImage] = useState(null);
    const [usernameAvailable, setUsernameAvailable] = useState(true);
    const [emailAvailable, setEmailAvailable] = useState(true);

    useEffect(() => {
        dispatch(get_user_articles_thunk({ token })).then((res) => {
            setEmail(res?.email)
            setUsername(res?.username)
        });
    }, [])

    const handleImageChange = (event) => {
        const files = event.target.files;
        if (files && files.length > 0) {
            const file = files[0];
            setSelectedImage(file);
            dispatch(setUserArticle({ ...userArticle, avatar: URL.createObjectURL(file) }));
        }
    };

    const updateUserArticle = async () => {
        if (!usernameAvailable) {
            dispatch(setErrorAlert("Username is already taken"))
            return
        }

        let body = userArticle
        if (userArticle?.avatar?.includes('blob')) {
            dispatch(setLoader(true))
            let url = await uploadImage(selectedImage)
            if (!url) {
                dispatch(setErrorAlert('Image cannot contain nudity, violence or drugs'));
                return
            }
            dispatch(setUserArticle({ ...userArticle, avatar: url }));
            body = { ...userArticle, avatar: url }
        }
        dispatch(update_user_article_thunk({ token, body }));
    }

    const handleUsernameChange = async (e) => {
        const username = e.target.value;
        dispatch(setUserArticle({ ...userArticle, username }));

        try {
            const res = await axios.post("/auth/checkUserName", { username });
            if (!res.data.data.exist) {
                setUsernameAvailable(true);
            } else {
                setUsernameAvailable(false);
            }
        } catch (error) {
            console.error('Error checking username:', error);
            setUsernameAvailable(false);
        }
    };

    const handleEmailChange = async (e) => {
        const email = e.target.value;
        dispatch(setUserArticle({ ...userArticle, email }));

        try {
            const res = await axios.get(`/auth/checkemail?email=${email}`);
            dispatch(setLoader(false));
            if (res.data.status === 200) {
                setEmailAvailable(true);
            }
            else {
                setEmailAvailable(false);
            }
        } catch (error) {
            console.error('Error checking email:', error);
            setEmailAvailable(false);
        }
    };

    return (
        <LayoutHeader>
            <div className="w-[390px] flex flex-col justify-start items-center relative z-[0] text-white">
                <div className='px-4 my-[50px] flex w-full justify-between'>
                    <p className='text-white'>Profile</p>
                    <div className='flex gap-[20px]'>
                        <button className='text-white cursor-pointer' onClick={() => {
                            updateUserArticle();
                            navigate('/team-member-dashboard');
                        }}>Confirm</button>
                        <p onClick={() => navigate('/team-member-dashboard')} className='text-white cursor-pointer'>Go back</p>
                    </div>
                </div>

                <div className='w-full px-4'>
                    <div className='flex flex-col justify-between'>
                        <div className='py-6 flex justify-between items-center'>
                            <ImageCard
                                txt="Change profile image"
                                dotimgclss={false}
                                onImageChange={handleImageChange}
                                imagePreview={userArticle?.avatar}
                            />
                        </div>

                        <div className='py-6 flex justify-between items-center'>
                            <button>Edit name</button>
                            <div className='relative flex gap-x-1 items-center'>
                                <DizeeInput2
                                    label="Link"
                                    placeholder="Edit name"
                                    className="dizee-input text-right"
                                    value={userArticle?.username}
                                    onChange={handleUsernameChange}
                                />
                                {usernameAvailable && (
                                    <Check className='h-[12px] w-[18px] cursor-pointer absolute right-[-24px] mt-[5px]' />
                                )}
                            </div>
                        </div>

                        <div className='py-6 flex justify-between items-center'>
                            <button>Change email</button>
                            <div className='relative flex gap-x-1 items-center'>
                                <DizeeInput2
                                    label="Email"
                                    placeholder="Change email"
                                    className="dizee-input text-right"
                                    value={userArticle?.email}
                                    onChange={handleEmailChange}
                                />
                                {emailAvailable && (
                                    <Check className='h-[12px] w-[18px] cursor-pointer absolute right-[-24px] mt-[5px]' />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </LayoutHeader>
    );
} 